<template>
	<div class="containerPage workIncome-page" id="workIncome-page">
		<!-- Total内容区 -->
		<div class="total" id="total">
			<div class="top">
				<div class="Title">Total Income</div>
				<div class="btn">
					<el-button class="draw" @click="dialogVisible = true">Withdraw</el-button>
					<el-button class="Recond" @click="dialogVisibleone = true">Record</el-button>
				</div>
			</div>
			<div class="middle"></div>
			<div class="bottom">
					<div class="content" v-for="(item,index) in TotalList" :key="index" >
						<div class="title" >
							<div>{{item.label}}</div>
							<div :style="index==1?'display:none':''">
								<el-tooltip class="item" effect="dark" :content="index==0?totaltips:amounttips" placement="top">
								      <i class="el-icon-warning" style="color: red;padding-left: 5px;"></i>
								</el-tooltip>
								
							</div>
						</div>
						<div class="number">{{item.value}}</div>
					</div>
			</div>
		</div>
		<div class="sector">
			<div class="top-bar">
				<div class="carry">Carry Over</div>
				<div class="Vertical"></div>
				<div class="money">${{carryOver}}</div>
			</div>
			<div class="tabStyle">
				<el-tabs v-model="activeName" @tab-click="handleClick" class="diy-tab">
					<el-tab-pane :label="item.label" :key="item.label" :name="item.label" v-for="item in tablist">
						<span slot="label">
						      <span class="span-box" >
						        <span>{{ item.label }}</span>
						        <el-tooltip v-if="item.label=='Daily Coins Report'"
						          class="item" placement="top"
						        >
								<div slot="content">
								　　Only the books signed under an agreement of net revue type could check the daily coins report. <br/>
								　　The daily coins report are not available for the books signed under an agreement of profit share type.<br/>
								  </div>
						          <i class="el-icon-warning" style="color: red;padding-left: 5px;"></i>
						        </el-tooltip>
						      </span>
						    </span>
						<Incomehistory v-show="item.label=='Income history'" @Income-click="Incomeobtain($event)" @showlist="showlist($event)"></Incomehistory>
						<CoinsReport v-show="item.label=='Daily Coins Report'" :booklist="booklist"></CoinsReport>
					</el-tab-pane>
				</el-tabs>
			</div>
		</div>
		<div v-show="activeName=='Income history'">
			<div class="my-book" >
				<div style="display: flex;">
					<div class="book">My books</div>
					<el-button class="more" @click="more()">More</el-button>
				</div>
			</div>
			<mybook :booklist="booklist"></mybook>
			<div class="list" v-for="item in Profitlist" >
				<div class="above" @click="show(item.id)">
					<div class="alltitle">{{item.name}}</div>
					<div class="above-middle"></div>
					<div class="allmoney">{{item.money}}</div>
				</div>
				<div v-for="item1 in item.children" >
					<div class="below" v-show="showstatus && item1.bookName" >
						<div class="alltitle">{{item1.bookName}}</div>
						<div class="allmoney">{{screen(item1,item.name)}}</div>
					</div>
				</div>
			</div>
		</div>
		<!-- withdraw弹窗 -->
		<div>
		<el-dialog title="Withdrawal Request" :visible.sync="dialogVisible" width="60%" :before-close="handleClose">
		  <withdraw :totalIncome="totalIncome" @cancella="paymenydata($event)"></withdraw>
		</el-dialog>
		<el-dialog title="Record Request" :visible.sync="dialogVisibleone" width="60%" :before-close="handleCloseone" v-if="dialogVisibleone"><recond></recond>
		</el-dialog>
		</div>
	</div>
</template>

<script>
import Incomehistory from '../../components/Income-history';
import CoinsReport from '../../components/Coins-Report';
import mybook from '../../components/mybook.vue';
import withdraw from '../../components/withdraw.vue';
import recond from '../../components/recond.vue';
import { apiGetIncomeSummary,apiGetAuthorWorksListone} from '../../common/api/workincome.js'
export default{
	components: {
		Incomehistory,
		CoinsReport,
		mybook,
		withdraw,
		recond
	},
	data(){
		return{
			TotalList:[
				{id:1,label:"Total income",value:0.00},
				{id:2,label:"Received Payment",value:0.00},
				{id:3,label:"Amount Payable",value:0.00},
			],
			carryOver:0.00,
			tablist:[
				{id:1,label:"Income history",value:"Income history"},
				{id:2,label:"Daily Coins Report",value:"Daily Coins Report"}
			],
			booklist:[],
			activeName:"Income history", //tab的值
			year:"",//年
			month:"",//月
			statusdraw:false,//withdraw弹窗开启
			dialogVisible: false,
			dialogVisibleone: false,
			Incomedata:[],//子组件Income-history的数据
			showstatus:false, //是否展示列表
			Profitlist:[
				{id:1,name:"Profit Share",money:"$0.00", children:[]},
				{id:2,name:"Revenue",money:"$0.00", children:[]},
				{id:3,name:"Special Bonus",money:"$0.00", children:[]},
				{id:4,name:"Signing Bonus",money:"$0.00",children:[]},
				{id:5,name:"Updating Bonus",money:"$0.00",children:[]},
				{id:6,name:"Completion Bonus",money:"$0.00",children:[]},
				{id:7,name:"Channel Income",money:"$0.00",children:[]},
				{id:8,name:"Advance payment",money:"$0.00",children:[]},
				{id:9,name:'One-time Payment',money:"$0.00",children:[]},
				{id:10,name:'Withdrawalable Advance Payment/ One-time Payment',money:"$0.00",children:[]},
				{id:11,name:'Fixed Salary',money:"$0.00",children:[]},
			],
			tableData:[],
			totalIncome:0,
			totaltips:"Total Income = Received Payment + Amount Payable",
			amounttips:"'Amount Payable' refers to the amount of income that will be paid out on this month payment day."
		}
	},
	created(){
		this.getTotalList()
		this.getbooklist()
	},
	methods:{
		getTotalList(){
			let data={
				data:{
					userId: this.$store.state.userInfo == undefined ? 0 : this.$store.state.userInfo.id,
				}
			}
			apiGetIncomeSummary(data).then(res=>{
				if(res.code == 0){
					this.TotalList.forEach(item => {
					   item.value = item.id==1?this.adjust(res.data.totalIncome,2):item.id==2?this.adjust(res.data.receivedPayment,2):this.adjust(res.data.amountPayable,2)
					   this.totalIncome = res.data.amountPayable
					   if(item.value == 0){
						   item.value  = "0.00"
					   }
					});
					this.carryOver = res.data.carryOver == 0 ? '0.00':this.adjust(res.data.carryOver,2)
				}
			})
		},
		
		//获取书籍列表
		getbooklist(){
			let bookdata={
				data:{
					works:{
						userId: this.$store.state.userInfo == undefined ? 0 : this.$store.state.userInfo.id,
						signStatus:1
					}	
				}
			}
			apiGetAuthorWorksListone(bookdata).then(res=>{
				if(res.code == 0){
					res.data.forEach(item => {
							this.booklist.push(item.works)
							
					});
					
				}
			})
		},
		handleClose(done) {
		  this.$confirm('Confirm the shut down？')
		    .then(_ => {
		      done();
		    })
		    .catch(_ => {});
		},
		handleCloseone(done) {
		  this.$confirm('Confirm the shut down？')
		    .then(_ => {
		      done();
		    })
		    .catch(_ => {});
		},
		//切换tab
		handleClick(){
		},
		search(){
			
		},
		//跳转到更多书籍页面
		more(){
			this.$router.push({
				path: '/income/morebook',
				query:{
					booklist:this.booklist
				}
			})
			
		},
		dailyicon(){
			// this.$message({
			// 	message:"Only the books signed under an agreement of net revue could check the daily coins report.The daily coins report are not available for the books signed under an agreement of profit share type."
			// })
		},
		//获取子组件Income-history的数据
		Incomeobtain(e){
			this.Incomedata = e
			this.$nextTick(() => {
			   this.Profitlist[0].money = '$' + this.adjust(this.Incomedata.profit,2)
			   this.Profitlist[1].money = '$' + this.adjust(this.Incomedata.revenue,2)
			   this.Profitlist[2].money = '$' + this.adjust(this.Incomedata.specialBonus,2)
			   this.Profitlist[3].money = '$' + this.adjust(this.Incomedata.signingBonus,2)
			   this.Profitlist[4].money = '$' + this.adjust(this.Incomedata.dailyUpdateBonus,2)
			   this.Profitlist[5].money = '$' + this.adjust(this.Incomedata.completionBonus,2)
			   this.Profitlist[6].money = '$' + this.adjust(this.Incomedata.channelRevenue,2)
			   this.Profitlist[7].money = '$' + this.adjust(this.Incomedata.advancePayment,2)
			   this.Profitlist[8].money = '$' + this.adjust(this.Incomedata.onetimePayment,2)
			   this.Profitlist[9].money = '$' + this.adjust(this.Incomedata.withdrawableAmount,2)
			   this.Profitlist[10].money = '$' + this.adjust(this.Incomedata.basicSalary,2)
			});
			
		},
		//获取子组件withdraw的数据
		paymenydata(e){
		  this.dialogVisible = e
		},
		screen(item1,name){
			switch(name){
				case 'Profit Share':
					return '$' + this.adjust(item1.profit,2)
					break;
				case 'Revenue':
					return '$' + this.adjust(item1.revenue,2)
					break;
				case 'Special Bonus':
					return '$' + this.adjust(item1.specialBonus,2)
					break;
				case 'Signing Bonus':
					return '$' + this.adjust(item1.signingBonus,2)
					break;
				case 'Updating Bonus':
					return '$' + this.adjust(item1.dailyUpdateBonus,2)
					break;
				case 'Completion Bonus':
					return '$' + this.adjust(item1.completionBonus,2)
					break;
				case 'Advance payment':
					return '$' + this.adjust(item1.advancePayment,2)
					break;
				default:
				    return "0.00"
			}

		},
		//最下方的数据展示
		show(id){
			id = id - 1
		
			this.showstatus = false
			if(this.Profitlist[id].children.length == 0){
				this.Profitlist[id].children = this.Incomedata.children
				this.showstatus = true
			}
			if(this.Profitlist[id].children.length>0&&!this.showstatus){
				this.Profitlist[id].children = []
				this.showstatus = true
			}
		},
		//获取子组件Income-history的数据
		showlist(val){
			this.showstatus = val
			for(let i in this.Profitlist){
				this.Profitlist[i].children = []
			}
		},
		//四舍五入
		adjust(numberRound,roundDigit){
		  if (numberRound>=0){
		  var tempNumber = parseInt((numberRound * Math.pow(10,roundDigit)+0.5))/Math.pow(10,roundDigit);
		  tempNumber += ''
		  if (!/\./.test(tempNumber)) {
		      tempNumber += '.00'
		  }
		  var arrayNum = tempNumber.split('.')
		  if (arrayNum[1].length < 2) {
		     tempNumber += '0'
		  }
		  return tempNumber;
		  } else{
		  var numberRound1=-numberRound;
		  var tempNumber = parseInt((numberRound1 * Math.pow(10,roundDigit)+0.5))/Math.pow(10,roundDigit);
		  return -tempNumber;
		
		  }
		}
		
	}
	}
</script>

<style lang="scss" scoped="scoped">
	.workIncome-page{
		background-color: transparent;
		.total{
			background-color: white;
			width: 100%;
			.top{
				padding:10px 40px 10px 20px;
				display: flex;
				height: auto;
				.Title{
					flex:1;
					font-size: 20px;
					font-weight: 600;
					line-height: 40px;
					color: rgb(34, 34, 34);
				}
				.btn{
					flex: 0;
					display: flex;
				}
				.draw{
					border: 0px solid red;
					border-radius: 5px;
					background: antiquewhite;
					color: coral;
					font-weight: 600;
				}
				.Recond{
					background: white;
					border: 2px solid #ccc;
					border-radius: 5px;
					color: #ccc;
					margin-left: 20px;
					font-weight: 600;
				}
				
			}
			.middle{
				border:1px solid #CCC;
				margin: 10px 0px 10px 0px;
			}
			.bottom{
				display: flex;
				width: calc(80%);
					.content{
						margin: auto;
						margin-left: 30px;
						.title{
							display: flex;
							
						}
						.number{
							text-align: center;
							font-size: 30px;
							color: black;
							font-weight:700;
							margin: 10px 10px 20px 0px;
						}
					}
			}
		}
		.sector{
			background-color: white;
			width: 50%;
			margin-top: 10px;
			.top-bar{
				background-color: #F2F2F2;
				position: relative;
				top: 20px;
				// left: 10px;
				border-radius: 5px;
				display: flex;
				padding: 3px 0px 3px 0px;
				margin: 5px 5px;
				.carry{
					flex-grow: 1;
					padding-left: 100px;
					font-weight: 600;
				}
				.Vertical{
					border-left: 1px solid black;
					width: 20%;
				}
				.money{
					flex-grow: 1;
					font-weight: 600;
					color: black;
					font-size: 15px;
				}
			}
			.tabStyle{
				margin-top: 60px;
				/deep/.el-tabs__active-bar{
					background-color: coral;
				}
				/deep/.el-tabs__item.is-active{
					color: coral;
				}
				::v-deep .el-tabs__item {
				    &:hover {
				      color: coral;
				    }
				  }
				
			}
		}
		.my-book{
			background-color: white;
			width: 50%;
			margin-top: 10px;
			position: relative;
			box-shadow: 0px 1px 4px rgba(0,0,0,0.3),0px 0px 50px white inset;
			.book{
				font-size: 15px;
				font-weight: 600;
				color: black;
				flex: 1;
				margin: 10px 0px 10px 10px;
			}
			.more{
				color: red;
				// margin: 10px 10px 10px 10px;
				border: 0px solid red;
			}
		}
		.list{
			width: 50%;
			margin-top: 20px;
			// display: flex;
			.above{
				background-color: #ccc;
				display: flex;
				padding: 5px 0px 5px 0px;
				border-radius: 3px;
				display: flex;
				// flex-direction: row;
				// justify-content: space-between;
			}
			.above-middle{
				border-left: 3px solid whitesmoke;
			}
			.below{
				border-bottom-left-radius: 10;
				background-color: antiquewhite;
				display: flex;
				padding: 5px 0px 5px 0px;
				border-radius: 3px;
				display: flex;
				// flex-direction: row;
				// justify-content: space-between;
				border-top-color: white;
				border-top-style: outset;
			}
			.alltitle{
				width: 50%;
				text-align: center;
			}
			.allmoney{
				width: 50%;
				position: absolute;
				right: 15%;
			}
		}
		
	}
</style>